import flowRight from 'lodash/flowRight';

const compose = flowRight;

export default compose;
